import { format as fnsFormat } from 'date-fns'
import { ja } from 'date-fns/locale'
import { parseDate } from '../parseDate'

export const dateToStringWithWeekday = (dateStr: string, format: 'short' | 'long' = 'short'): string => {
  const parsedDate = parseDate(dateStr)
  if (!parsedDate) {
    throw new Error('Invalid date string')
  }
  return fnsFormat(parsedDate, format === 'long' ? 'yyyy/M/d (eee)' : 'M/d (eee)', { locale: ja })
}
